import send from 'service/index';

export default {
    // 获取所有一级的游戏
    getReturnCommissionWeb(params: any = {}) {
        return send({
            url: '/agent/getReturnCommissionWeb',
            method: 'get',
            params,
        });
    },
    // 代理排行榜前三
    getTopThree(params: any = {}) {
        return send({
            url: '/agent/topThree',
            method: 'get',
            params,
        });
    },
    // 代理奖金列表
    getTopAllAgent(params: any = {}) {
        return send({
            url: `/preferential/preferentialActivity/findTopAllAgent/${params.top}`,
            method: 'get',
        });
    },
    // 代理返佣配置
    getAgentCommissionConfigList(params: any = {}) {
        return send({
            url: '/agent/getAgentCommissionConfigList',
            method: 'get',
            params,
        });
    },
    // 代理成就规则
    getPreferentialActivity(params: any = {}) {
        return send({
            url: `/preferential/preferentialActivity/findAgentAchievementRules/${params?.isGetCount}`,
            method: 'get',
        });
    },
    // 优惠活动任务
    findGameTaskRules(params: any = {}) {
        return send({
            url: `/preferential/preferentialActivity/findGameTaskRules/${params?.id}`,
            method: 'get',
        });
    },
    // 完善信息任务
    findCompleteInfoRules(params: any = {}) {
        return send({
            url: `/preferential/preferentialActivity/findTaskRules/${params?.id}`,
            method: 'get',
        });
    },
    // 通用任务规则（如存款宝箱）
    findTaskRules(id: number) {
        return send({
            url: `/preferential/preferentialActivity/findTaskRules/${id}`,
            method: 'get',
        });
    },
    // 优惠活动详情
    findById(params: any = {}) {
        return send({
            url: `/content/activity/findById/${params?.id}`,
            method: 'get',
        });
    },
    // 代理活动申请
    getPreferentialActivityApply(data: any = {}) {
        return send({ data, url: '/preferential/preferentialActivity/apply', method: 'post' });
    },
    // 红包雨
    getPreferentialRedEnvelope(data: any = {}) {
        console.log(data,'data')
        return send({ data, url: `/preferential/preferentialActivity/findRedBonus/${data?.preferentialActivityId}`});
    },   
     // 红包雨规则和时间
    getPreferentialRedBonusInfo(data: any = {}) {
        console.log(data,'data')
        return send({ data, url: `/preferential/preferentialActivity/findRedBonusInfo/${data?.preferentialActivityId}`});
    },
    // 今日获利&利润总额
    getMyBonus(params: any = {}) {
        return send({ params, url: '/agent/getMyBonus', method: 'get' });
    },
    // 充值返利
    getFindAgent(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findAgent/${params?.current}/${params?.size}/${params?.timeType}`, method: 'get' });
    },
    getFindAgentTotal(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findAgentCommission/${params?.timeType}`, method: 'get' });
    },
    // 投注回扣
    getAgentCommissionRecord(params: any = {}) {
        return send({ params, url: `/agent/getAgentCommissionRecord/${params?.current}/${params?.size}/${params?.timeType}`, method: 'get' });
    },
    // 代理层级
    getAgentLevelSum(data: any = {}) {
        return send({ data, url: `/agent/levelSum`, method: 'post' });
    },
    // 邀请奖励
    getAgentInvitationBonus(params: any = {}) {
        return send({ params, url: '/preferential/preferentialActivity/findAgentInvitationBonus', method: 'get' });
    },
    // 帮助中心列表
    getFindHomeHelp(params: any = {}) {
        return send({ params, url: '/content/contentHelp/findHomeHelp', method: 'get' });
    },
    // 帮助中心详情
    getHomeHelpFindById(params: any = {}) {
        return send({ url: `/content/contentHelp/findById/${params?.id}`, method: 'get' });
    },
    // 帮助中心faq
    getFindFAQ(params: any = {}) {
        return send({ url: `/content/contentHelp/findFAQ`, method: 'get' });
    },
    // H5 书签
    getFindBookmark(params: any = {}) {
        return send({ url: `/content/contentHelp/findBookmark/${params?.browser}`, method: 'get' });
    },
    // 领取佣金
    getCommissionReceive(params: any = {}) {
        return send({ url: `/agent/commissionRecord/receive/${params?.gameType}`, method: 'get' });
    },
    // 代理记录
    getAgnetMoneyList(data: any = {}) {
        return send({ data, url: `/member/getAgentMoneyList/${data.page}/${data.rows}`, method: 'post' });
    },
    // 代理转出
    updateAgentMoney(data = {}) {
        return send({ data, url: '/member/updateAgentMoney', method: 'post' });
    },
    // 优惠活动
    findPage(params = {}) {
        return send({ params, url: '/content/activity/findHomeAds', method: 'get' });
    },
    // 超级大奖
    findGameBetPreferential(params = {}) {
        return send({ params, url: '/preferential/preferentialActivity/findGameBetPreferential', method: 'get' });
    },
    // 超级大奖详情列表
    findBetBonus(data: any = {}) {
        return send({ data, url: `/preferential/preferentialActivity/findBetBonus/${data?.current}/${data?.pageSize}`, method: 'post' });
    },
    // 锦标赛活动详情
    findChampionship(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findChampionship/${params?.activityId}/${params?.dayType}`, method: 'get' });
    },
    // 活动申请记录
    getPreferentialFlow(data: any = {}) {
        return send({ data, url: `/preferential/preferentialActivity/findPreferentialFlow/${data.page}/${data.rows}`, method: 'post' });
    },

    // 邀请奖励以及每日邀请上限
    getAgentInvited() {
        return send({ url: `/preferential/preferentialActivity/findAgentInvited`, method: 'get' });
    },

    // 获取团队明细上部分
    getLevelSumV2() {
        return send({ url: `/agent/levelSumV2`, method: 'get' });
    },

    // 代理返佣规则
    getCommissionConfig() {
        return send({ url: `/agent/commissionConfig/findCommissionConfig`});
    },

    // 代理升星规则
    getAgentCommissionStarConfig() {
        return send({ url: `/agent/commissionConfig/findCommissionStarConfig`});
    },

    // 神秘奖金
    findMysteryBonus(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findMysteryBonus`, method: 'get' });
    },

    // 等级奖金
    findLevelBonus(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findLevelBonus`, method: 'get' });
    },

    // 等级奖金
    findSignInBonus(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findSignInBonus`, method: 'get' });
    },

    // 存款宝箱
    findDepositTreasure(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findDepositTreasure`, method: 'get' });
    },

    // 救援金活动,周工资
    findGamePreferentialRules(params: any = {}) {
        return send({ params, url: `/preferential/preferentialActivity/findGamePreferentialRules/${params.preferentialActivityId}`, method: 'get' });
    },
};
